var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.5858 3.99997C19.9609 3.6249 20.4696 3.41418 21 3.41418C21.5304 3.41418 22.0391 3.6249 22.4142 3.99997L21.7457 4.66851L22.4142 3.99997L28 9.58576C28.3751 9.96083 28.5858 10.4695 28.5858 11C28.5858 11.5304 28.3751 12.0391 28 12.4142L12.7071 27.7071C12.5196 27.8946 12.2652 28 12 28H6C5.46957 28 4.96086 27.7893 4.58579 27.4142C4.21071 27.0391 4 26.5304 4 26V20.4142C4 20.1515 4.05173 19.8915 4.15224 19.6488C4.25275 19.4062 4.40007 19.1857 4.58579 19L19.5858 3.99997ZM26.5858 11L21 5.41418L6 20.4142L5.29289 19.7071L6 20.4142L6 26H11.5858L26.5858 11Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.2929 7.29289C16.6834 6.90237 17.3166 6.90237 17.7071 7.29289L24.7071 14.2929C25.0976 14.6834 25.0976 15.3166 24.7071 15.7071C24.3166 16.0976 23.6834 16.0976 23.2929 15.7071L16.2929 8.70711C15.9024 8.31658 15.9024 7.68342 16.2929 7.29289Z"
});

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.31a071a0f5eae84ee54c6a03ed2e0a8f.svg";
export { ForwardRef as ReactComponent };